import React from "react";
import { Outlet } from "react-router-dom";
import ProviderSidebar from "./ProviderSidebar";
import ProviderTopbar from "./ProviderTopbar";
import ProviderSetupBanner from "./ProviderSetupBanner";

type ProviderDashboardLayoutProps = {
  children?: React.ReactNode;
};

const sidebarWidth = 280;
const background = "#f8fafc";
const contentPanel = "#ffffff";
const borderColor = "#e5e7eb";

const ProviderDashboardLayout: React.FC<ProviderDashboardLayoutProps> = ({
  children,
}) => {
  const content = children ?? <Outlet />;

  return (
    <div
      style={{
        minHeight: "100vh",
        background,
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `${sidebarWidth}px minmax(0, 1fr)`,
          minHeight: "100vh",
        }}
      >
        <aside
          style={{
            minHeight: "100vh",
            borderRight: `1px solid ${borderColor}`,
            background: "#ffffff",
          }}
        >
          <ProviderSidebar />
        </aside>

        <div
          style={{
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ProviderTopbar />

          <main
            style={{
              flex: 1,
              padding: "1.5rem",
            }}
          >
            <ProviderSetupBanner />

            <section
              aria-label="Provider dashboard content"
              style={{
                marginTop: "1rem",
                background: contentPanel,
                borderRadius: 20,
                border: `1px solid ${borderColor}`,
                padding: "1.5rem",
                minHeight: 520,
                boxShadow:
                  "0 1px 2px rgba(15, 23, 42, 0.04), 0 12px 32px rgba(15, 23, 42, 0.06)",
              }}
            >
              {content}
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ProviderDashboardLayout;